import clsx from 'clsx';
import React from 'react';
import { prepareData } from 'utils/googleData';

export default function SimpleUse(props) {
  const {
    enable,
    title,
    cards,
  } = prepareData({ props });

    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
    return <></>
  }

  return (
    <section className="relative bg-gradient-to-br from-[#0B1C39] via-[#1a2a4a] to-[#0B1C39] py-32 md:py-24 sm:py-20 overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-blue-500/10 via-transparent to-transparent"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-px bg-gradient-to-r from-transparent via-blue-400/50 to-transparent"></div>
      
      <div className="px-4 relative z-10">
        {/* Header */}
        <div className="text-center mb-20 md:mb-16 sm:mb-12">
          <h2 className="text-5xl md:text-4xl sm:text-3xl font-bold text-white mb-6 leading-tight">
            {title}
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-400 to-cyan-400 mx-auto rounded-full"></div>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 md:gap-6 sm:gap-4">
          {cards?.length > 0 && cards.map(({ Icon, title }, index) => (
            <div
              key={index}
              className="group relative"
              style={{
                animationDelay: `${index * 100}ms`
              }}
            >
              {/* Card Background */}
              <div className="relative bg-gradient-to-br from-white/5 to-white/10 backdrop-blur-xl border border-white/10 rounded-2xl p-8 md:p-6 sm:p-5 h-full transition-all duration-500 hover:from-white/10 hover:to-white/15 hover:border-white/20 hover:shadow-2xl hover:shadow-blue-500/20 hover:-translate-y-2">
                {/* Hover Glow Effect */}
                <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-blue-500/20 to-cyan-500/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                
                {/* Content */}
                <div className="relative z-10 flex flex-col items-center text-center">
                  {Icon && (
                    <div className="mb-6 relative">
                      {/* Icon Background Glow */}
                      <div className="absolute inset-0 bg-gradient-to-br from-blue-400/30 to-cyan-400/30 rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-500"></div>
                      
                      {/* Icon Container */}
                      <div className="relative bg-gradient-to-br from-white/40 to-white/20 backdrop-blur-md border-2 border-white/40 rounded-2xl p-3 md:p-2.5 sm:p-2 group-hover:border-white/60 group-hover:from-white/50 group-hover:to-white/30 group-hover:shadow-lg group-hover:shadow-blue-500/30 transition-all duration-300">
                        <Icon className="h-24 md:h-22 sm:h-20 w-auto text-white group-hover:text-blue-100 transition-all duration-300 group-hover:scale-110" />
                      </div>
                    </div>
                  )}
                  
                  <h3 className="text-lg md:text-base sm:text-sm font-semibold text-white group-hover:text-blue-100 transition-colors duration-300 leading-tight">
                    {title}
                  </h3>
                </div>
                
                {/* Decorative Elements */}
                <div className="absolute top-4 right-4 w-2 h-2 bg-blue-400/60 rounded-full group-hover:bg-blue-300 transition-colors duration-300"></div>
                <div className="absolute bottom-4 left-4 w-1 h-1 bg-cyan-400/60 rounded-full group-hover:bg-cyan-300 transition-colors duration-300"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
